module.exports = __webpack_public_path__ + "media/confirm_sound.4c68b2be.mp3";